<template>
  <div class="tab-group-container">
    <ul class="tab-group">
      <li
          v-for="(v, i) in tabs"
          :class="{'active-tab': _index === i}"
          @click="onChangeTab(i)"
      >
        <div class="tab-name">{{ v.name }}</div>
        <div class="tab-divide"></div>
      </li>
    </ul>
  </div>
</template>

<script setup>
import {computed, ref, watch} from "vue";
import {isEmptyNumber} from '@/tool/number'

const props = defineProps(['data', 'index'])
const emits = defineEmits(['onChangeTab'])
const j = ref(0)
const _index = computed(() => {
  return  isEmptyNumber(props.index) ? j.value : props.index;
})

const tabs = computed(() => {
  return props.data.map((e) => ({name: e}))
})

const onChangeTab = v => {
  j.value = v;
  emits('onChangeTab', v);
}

watch(() => props.index, (v) => {
  j.value = v;
})
</script>

<style lang="less" scoped>
.tab-group {
  color: #333;
  font-size: 14px;
  font-weight: 400;
  background-color: #e6f2ff;
  float: left;
  display: flex;

  &-container{
    height: 30px;
  }

  &::after{
    clear: both;
  }

  & li{
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;


    &.active-tab {
      background: url(../assets/images/bg_tab.png) no-repeat left 0;
      background-size: 100% 66px;
      color: #fff;

      & .tab-divide{
          border-right: 1px solid transparent;
      }
    }

    &:last-child.active-tab{
        background: url(../assets/images/bg_tab.png) no-repeat right -35px;
        background-size: 100% 66px;
        color: #fff;
    }

    &:last-child{
      & .tab-divide{
        border-right: 1px solid transparent;
      }
    }

    & .tab-name{
      flex: 1;
      text-align: center;
      height: 30px;
      line-height: 30px;
      padding: 0 16px;
    }

    & .tab-divide{
      width: 1px;
      height: 14px;
      border-right: 1px solid #b7daff;
    }
  }
}
</style>